export default __webpack_public_path__ + "static/media/bootstrap.e94a8085.png";